import moment from 'moment';

export function getDateTransformDate(date: string): string {
  const [year, month, day] = date.slice(0, 10).split('-');
  return `${day}-${month}-${year}`;
}

export function formatDateExport(dateString: string): string {
  if (!dateString) return '';
  const trimmed = dateString.trim();
  const ymdMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
  if (ymdMatch) {
    return `${ymdMatch[3]}/${ymdMatch[2]}/${ymdMatch[1]}`;
  }
  const dmyMatch = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/.exec(trimmed);
  if (dmyMatch) {
    const day = dmyMatch[1].padStart(2, '0');
    const month = dmyMatch[2].padStart(2, '0');
    const year = dmyMatch[3];
    return `${day}/${month}/${year}`;
  }
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  const day = ('0' + date.getUTCDate()).slice(-2);
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

export function convertTo12HourTime(fechaString: string): string {
  const fecha = new Date(fechaString);
  let horas = fecha.getHours();
  const minutos = fecha.getUTCMinutes();
  const ampm = horas >= 12 ? 'PM' : 'AM';

  horas = horas % 12 || 12;
  return `${horas}:${minutos.toString().padStart(2, '0')} ${ampm}`;
}

export function getDateRangeStart(dateRange: string): Date {
  const [range1Str] = dateRange.split('-').map((s) => s.trim());
  const [day, month, year] = range1Str
    .split('/')
    .map((num) => parseInt(num, 10));
  return new Date(year, month - 1, day);
}

export function getDateRangeEnd(
  dateRange: string,
  diasItinerario: number
): Date {
  const dateFinal = new Date(getDateRangeStart(dateRange));
  dateFinal.setDate(dateFinal.getDate() + diasItinerario);
  return dateFinal;
}

export function showDateFromRange(dateRange: string, day: string): Date {
  const fechaInicio = moment(dateRange, 'DD.MM.YYYY').toDate();
  fechaInicio.setDate(fechaInicio.getDate() + parseInt(day, 10) - 1);
  return fechaInicio;
}

export function formatFlightHour(hora: string): string {
  if (!hora) return '-';
  const [hours, minutes] = hora.split(':');
  return `${hours}:${minutes}`;
}

export function formatDateTimeValue(date: any): any {
  if (!isNaN(new Date(Date.parse(date)).valueOf())) {
    const parsed = new Date(date);
    const h = parsed.getHours().toString().padStart(2, '0');
    const m = parsed.getMinutes().toString().padStart(2, '0');
    return `${h}:${m}`;
  }
  return date;
}
